import React from 'react'
import {Modal} from 'react-bootstrap'
import './AuthorizationModal.css'
import deny from './deny-2.svg'
import logoMokaWhite from '../assets/logo-moka-white.png'
import mokaWhite from '../assets/moka-white.svg'
import * as mpAuthmodal from '../mixpanel/frags/authorizationModal'

class AuthorizationModal extends React.Component {
  static ALLOW = 'allow'
  static DENY = 'deny'

  constructor(props){
    super(props)
    this.state = {
      action: AuthorizationModal.ALLOW
    }
  }

  render(){
    const {currentResourceOwner, preAuth, oauthAuthorizationPath,scopeDescriptions,scopeLabels} = this.props
    return <div>
      <Modal show={this.state.action === AuthorizationModal.ALLOW} backdrop={false}>
        {this._header({action:  AuthorizationModal.ALLOW})}
        <Modal.Body>
          <div className="content-container">
            <div className='components-authorization-modal__logo_wrapper mt-10px'>
              <div className='components-authorization-modal__moka_logo_wrapper'>
                {<img src={logoMokaWhite}/>}
              </div>
              <i className='fa fa-angle-right'/>
              {!preAuth.client.application.logo.url && <i className='fa fa-image'/>}
              {!!preAuth.client.application.logo.url && <img src={preAuth.client.application.logo.url}/>}
            </div>
            <p className="text-center mb-20px"> 
              Saya memberikan persetujuan kepada <b>Moka</b> untuk dapat
              mengirimkan hal-hal berikut kepada{' '}
              <b>Mitra Pihak Ketiga Penyedia Layanan</b>:
            </p>
            <ul style={{paddingLeft: '10px'}}>
              {preAuth.client.application.scopes.map((scope) => {
                return <li style={{listStyle: 'none'}}>
                  <div className="c-doorkeeper-authorizations-new__scope_title">{scopeLabels[scope]}</div>
                  <div className="c-doorkeeper-authorizations-new__scope_description">{scopeDescriptions[scope]}</div>
                </li>
              })}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
            <div className="components-authorization-modal__privacy_policy">
            <div>
              <span className='pull-left'>
                  Dengan menekan tombol "Setuju" maka saya menyetujui{' '}
                  <a
                    href="https://www.mokapos.com/syarat-dan-ketentuan#moka"
                    target="_blank"
                    data-testid="link-terms-and-conditions"
                  >
                    Ketentuan Penggunaan Moka Connect
                  </a>{' '}
                  dan{' '}
                  <a
                    href="https://www.mokapos.com/kebijakan-privasi"
                    target="_blank"
                    onClick={this._onClickPrivacyPolicy}
                    data-testid="link-privacy-policy"
                  >
                    Kebijakan Privasi
                  </a>{' '}
                  Moka.
              </span>
            </div>
            <div className={`components-authorization-modal__submit`}>
              <button className='btn btn-default components-authorization-modal__btn_submit' onClick={this._onClickDeny}>Batalkan</button>
              {this._submitForm({preAuth,oauthAuthorizationPath,action: AuthorizationModal.ALLOW})}
            </div>

          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={this.state.action === AuthorizationModal.DENY} backdrop={false}>
        {this._header({action: AuthorizationModal.DENY})}
        <Modal.Body>
          <div>
            <div className='components-authorization-modal__logo_wrapper components-authorization-modal__logo_wrapper_denied'>
              <img src={deny}/>
            </div>
            <div className='components-authorization-modal__title'>Tolong Berikan Akses</div>
            <p style={{lineHeight:'2.0'}} className='mb-35px ml-25px mr-25px'>Untuk berhasil menghubungkan Moka dengan <b>{preAuth.client.application.name}</b>, kami memerlukan akses kepada data Anda di Moka. 
              Anda dapat mencabut akses ini kapan saja.
            </p>
            <p  style={{lineHeight:'2.0'}} className='mb-25px ml-25px mr-25px'>
              Jika Anda memiliki pertanyaan atau masalah, tolong hubungi kami di <a href="mailto:support@mokapos.com">support@mokapos.com</a>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="components-authorization-modal__actions">
            <span className='pull-right'>
              <button className='btn btn-primary-default components-authorization-modal__btn_submit mr-20px' onClick={this._onClickCancel}>Batalkan</button>
              <button className='btn btn-primary components-authorization-modal__btn_submit' onClick={this._onClickTryAgain}>Coba Lagi</button>
            </span>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  }

  _header = ({action}) => {
    let additionalClass = action ===  AuthorizationModal.ALLOW ? 'components-authorization-modal__header_primary':'components-authorization-modal__header_primary'
    return <Modal.Header bsClass={`components-authorization-modal__header ${additionalClass}`}>
      <span>Hubungkan dengan {<img src={mokaWhite} className='components-authorization-modal__header_logo'/>}</span>
    </Modal.Header>
  }


  _onClickCancel = () => {
    mpAuthmodal.clickCancel({}, () => window.close())
  }

  _onClickDeny = () => {
    const {application} = this.props.preAuth.client
    this.setState({action: AuthorizationModal.DENY})
    mpAuthmodal.clickDeny({uid: application.uid, name: application.name})
  }

  _onClickTryAgain = () => {
    const {application} = this.props.preAuth.client
    this.setState({action: AuthorizationModal.ALLOW})
    mpAuthmodal.clickTryAgain({uid: application.uid, name: application.name})
  }

  _onClickAllow = () => {
    const {application} = this.props.preAuth.client
    mpAuthmodal.clickAllow({uid: application.uid, name: application.name})
  }

  _submitForm = ({preAuth, oauthAuthorizationPath,action}) => {
    return <div className={`${action=== AuthorizationModal.ALLOW?'allow':'deny'} components-authorization-modal__submit`}>
      <form action={oauthAuthorizationPath} method='post'>
        <input type='hidden' name='_method' value={action==='allow'?'post':'delete'}/>
        <input type="hidden" name="authenticity_token" value={this.props.csrfToken}/>
        <input type='hidden' name='client_id' value={preAuth.client.application.uid}/>
        <input type='hidden' name='redirect_uri' value={preAuth.redirect_uri}/>
        <input type='hidden' name='state' value={preAuth.state}/>
        <input type='hidden' name='response_type' value={preAuth.response_type}/>
        <input type='hidden' name='scope' value={preAuth.client.application.scopes.join(' ')}/>
        {action === AuthorizationModal.ALLOW && <input type='submit' name='commit' value='Setuju' className='btn btn-primary components-authorization-modal__btn_submit' onClick={this._onClickAllow} />}
      </form>
    </div>
  }

  _onClickPrivacyPolicy = () => {
    mpAuthmodal.policy()
  }
}

export default AuthorizationModal


// WEBPACK FOOTER //
// app/javascript/components/AuthorizationModal/AuthorizationModal.js